import { Button, Divider, FormControl, Input, InputGroup, InputRightElement, Image, Box } from '@chakra-ui/react';
import { FormEvent } from 'react';
import { useDispatch } from 'react-redux';
import FFLRecognizer from '@/utils/regexMatcher';
import { getLicenseApprovalFilterModel, getLicenseApprovalSearchText, getSOTApprovalFilterModel, getSOTApprovalSearchText, getLOAApprovalFilterModel, getLOAApprovalSearchText } from '../components/selector';
import { setLicenseApprovalFilterModel, setLicenseApprovalSearchText, setSOTApprovalFilterModel,setSOTApprovalSearchText, setLOAApprovalFilterModel, setLOAApprovalSearchText } from '../ducks/slice';

interface Props {
    placeholder: string;
    approvalType: string;
}

const useFilterAndSearchState = (approvalType: string): any => {
    return {
            "License Approval": {
                approvalFilterModel: getLicenseApprovalFilterModel(),
                approvalSearchText: getLicenseApprovalSearchText(),
                setApprovalFilterModel: setLicenseApprovalFilterModel,
                setApprovalSearchText: setLicenseApprovalSearchText,
            },
            "SOT Approval": {
                approvalFilterModel: getSOTApprovalFilterModel(),
                approvalSearchText: getSOTApprovalSearchText(),
                setApprovalFilterModel: setSOTApprovalFilterModel,
                setApprovalSearchText: setSOTApprovalSearchText,
            },
            "LOA Approval": {
                approvalFilterModel: getLOAApprovalFilterModel(),
                approvalSearchText: getLOAApprovalSearchText(),
                setApprovalFilterModel: setLOAApprovalFilterModel,
                setApprovalSearchText: setLOAApprovalSearchText,
            }
        }[approvalType];
}

function Search({placeholder, approvalType}: Props) {
  const dispatch = useDispatch();
  const {approvalFilterModel, approvalSearchText, setApprovalFilterModel, setApprovalSearchText} = useFilterAndSearchState(approvalType);

  // Event Handlers
  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setApprovalSearchText(event.target.value));
  };

  const onSubmit = (event: FormEvent) => {
    event.preventDefault();
    try {
      // Check to find valid regex match for 8 or 16 digit id
      const recognizer = new FFLRecognizer();
      const match = recognizer.matches(approvalSearchText.trim());
      const value =
        match && match.length > 3
          ? `${match[1]}${match[2]}${match[3]}`
          : approvalSearchText.trim();

      if (approvalFilterModel) {
        dispatch(
            setApprovalFilterModel({
            ...approvalFilterModel,
            searchText: {
              ...approvalFilterModel.searchText,
              filter: value
            }
          })
        );
      }
    } catch (error) {
      console.error('Failed to process the search:', error);
    }
  };

  return (
    <Box w={"50%"} mt={5}>
        <form onSubmit={onSubmit}>
            <FormControl whiteSpace={'nowrap'} padding={0}>
            <InputGroup className="input-group">
                <Input
                value={approvalSearchText}
                autoFocus
                placeholder={placeholder}
                onChange={onChangeHandler}
                height={'55px'}
                />
                <InputRightElement
                width="4.5rem"
                className="input-right-element"
                alignItems={'center'}
                >
                <Divider
                    orientation="vertical"
                    className="input-right-divider"
                />
                <Button type={'submit'} size={'sm'} backgroundColor={'#FFFFFF'}>
                    <Image src="/images/ui/searchIcon.svg"></Image>
                </Button>
                </InputRightElement>
            </InputGroup>
            </FormControl>
        </form>
    </Box>
  )
}

export default Search;